import icon from './svg/Listening';
import { createIconComp } from './Core/createIconComp';

export const ListeningIcon = createIconComp({ icon });
